import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { capitiliseFirstLetter } from 'utils/formatting'

const styles = theme => ({
  root: {
    borderRadius: 3,
    textAlign: 'center',
  },
  primary: {
    color: theme.palette.primary.main,
    backgroundColor: `${theme.palette.primary.main}40`,
  },
  tertiary: {
    color: theme.palette.tertiary.main,
    backgroundColor: theme.palette.tertiary.light,
  },
})

const getClassName = (classes, label) => {
  switch (label) {
    case 'primary':
      return classes.primary
    case 'tertiary':
      return classes.tertiary
    default:
      return null
  }
}

const TypeLabel = ({
  classes, className, label, color, width 
}) => (
  <div
    style={{ width }}
    className={classNames(
      classes.root,
      className,
      getClassName(classes, color)
    )}>
    <Typography>{capitiliseFirstLetter(label)}</Typography>
  </div>
)

TypeLabel.propTypes = {
  width: PropTypes.number,
  color: PropTypes.string,
  label: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
}

export default withStyles(styles)(TypeLabel)



// WEBPACK FOOTER //
// ./src/components/atoms/TypeLabel.js